module.exports = {
      id: "grid-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite.svg#grid",
      toString: function () {
        return this.url;
      }
    }